module.exports = __webpack_public_path__ + "img/N351-2-EN.d3ce15e9.png";